module.exports = __webpack_public_path__ + "static/media/natourssm.73dbfa90.JPG";